<template>
    <div class="dictionary clearfix">
        <!-- 商家项目管理 -->
        <!-- 所有商家的 -->
        <!-- 左侧选择商家 右侧商品列表 -->
        <div class="dictionary-left">
            <el-row class="dictionary-row">
                <el-col :span=18>
                    <span class="dictionary-row-span-ml"><img src="@/assets/beadhouse/juxing.png" alt=""
                            style="vertical-align:middle;"></span>
                    <span style="height:54px;line-height:54px;font-size:16px;">商家项目</span>
                </el-col>
                <el-col :span=3 :offset=3>
                </el-col>
            </el-row>
            <el-row style="width:90%;margin:10px auto;">
                <!-- 商家列表 -->
                <el-tree :data="treeList" node-key="id" :default-expand-all="false" :expand-on-click-node="false"
                    @node-click="handleNodeDictionary" :props="defaultProps">
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                        <span>{{ node.label }}</span>
                        <span>
                            <el-button type="text" size="mini" @click="() => appendDictionary(data)">
                                <img src="@/assets/beadhouse/bigjia.png" alt="" class="vertical-align-cursor">
                            </el-button>
                        </span>
                    </span>
                </el-tree>
            </el-row>
        </div>
        <div class="dictionary-right">
            <el-row>
                <el-row class="dictionary-row">
                    <el-col :span=2>
                        <span class="dictionary-row-span-ml"><img src="@/assets/beadhouse/juxing.png" alt=""
                                style="vertical-align:middle;"></span>
                    </el-col>
                    <el-col :span=4 :offset=9 style="font-size:16px">服务项目列表</el-col>
                    <el-col :span=2 :offset=7 align=center>
                    </el-col>
                </el-row>
            </el-row>
            <el-row style="margin-top:10px;">
                <!--表格内容栏-->
                <el-table :data="tableData" :header-cell-style="tableHeaderColor" style="width: 100%">
                    <el-table-column prop="imgsCode" label="图片" align="center" width="120px">
                        <template slot-scope="scope">
                            <el-image :src="scope.row.imgsCode" style="width:60px;height:60px"
                            @click="bigimage(scope.row.imgsCode)"
                            :preview-src-list="srcList"
                            />
                        </template>
                    </el-table-column>
                    <el-table-column prop="merchandiseName" label="名称" min-width="120" align=center></el-table-column>
                    <el-table-column prop="merchantId" label="商家" min-width="180" align=center></el-table-column>
                    <el-table-column prop="unitPrice" label="价格" width="120" align=center></el-table-column>
                    <el-table-column prop="isPutaway" label="上架" width="180" align=center>
                        <template slot-scope="scope">
                            <el-switch
                              :value="(scope.row.isPutaway==0)?true:false"
                              active-text="上架"
                              @change="changePutaway(scope.row)"
                              inactive-text="下架">
                            </el-switch>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" min-width="180" align=center>
                        <template slot-scope="scope">
                            <img src="@/assets/beadhouse/bianji_icon.png" alt="" class="imgSize"
                                @click="EditRow(scope.$index, scope.row)">
                            <img src="@/assets/beadhouse/shanchu_icon.png" alt="" class="imgSize"
                                @click="delet(scope.$index, scope.row)">
                        </template>
                    </el-table-column>
                </el-table>
            </el-row>
        </div>

        <!-- 商品弹窗 -->
        <el-dialog :title="isAdd ? '新增服务项目' : '修改服务项目'" width="32%" :visible.sync="dialogVisible" :close-on-click-modal="false"
            @close="closeDialogReset">
            <el-form :model="addForm" label-width="140px" :rules="dataFormRules" ref="dataForm" label-position="right">
                <el-row type="flex" justify="center">
                    <el-col>
                        <el-row>
                            <el-col :span="20">
                                <el-form-item label="项目名称:" prop="merchandiseName">
                                    <el-input v-model.trim="addForm.merchandiseName" clearable
                                        style="width: 200px;"
                                        placeholder="请输入项目名称"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row>
                            <el-col :span="20">
                                <el-form-item label="项目图片:" prop="imgsCode">
                                    <el-upload class="avatar-uploader" action="string" accept="image/png, image/jpeg"
                                        :show-file-list="false" list-type="picture-card" :before-upload="beforeUpload"
                                        :http-request="upload">
                                        <i v-if="addForm.imgsCode" class="el-icon-close closeIcon" style="color: #000"
                                            @click="closeImg"></i>
                                        <img style="width: 100%; height: 100%" v-if="addForm.imgsCode"
                                            :src="addForm.imgsCode" class="avatar" />
                                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                    </el-upload>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row>
                            <el-col :span="20">
                                <el-form-item label="服务类别:" prop="secondLevellId">
                                    <el-select
                                        style="width: 200px;"
                                        v-model="addForm.secondLevellId">
                                        <el-option
                                            v-for="item in secondServiceList"
                                            :key="item.id"
                                            :label="item.secondLevelName"
                                            :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>        

                        <el-row>
                            <el-col :span="20">
                                <el-form-item label="项目金额:" prop="unitPrice">
                                    <el-input-number v-model.trim="addForm.unitPrice" style="width: 200px"
                                        controls-position="right" :min="0" :max="9999" :precision="2" auto-complete="off"
                                        placeholder="请输入项目费用">
                                    </el-input-number>
                                    <div class="unit">元</div>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row>
                            <el-col :span="20">
                                <el-form-item label="项目描述:" prop="particulars">
                                    <el-input v-model.trim="addForm.particulars" clearable
                                        style="width: 200px;"
                                        type="textarea"
                                        :rows=3
                                        placeholder="请输入项目描述"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>

                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer" align="center">
                <el-button @click.native="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click.native="submitForm">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: "BusinessProgramManage",
    data() {
        return {
            isAdd: true,
            activeNames: "",
            server: [],
            tableList: [],
            dialogVisible: false,
            doctorDialogVisible: false, //专家
            addForm: {
                merchandiseName: "",
                imgsCode: "",
                remark: "",
                communityIds: [],
                secondLevelId: "",
            },
            treeList: [
                {
                    id: 1,
                    name: '社区',
                    remark: '社区',
                }],
            defaultProps: {
                children: 'children',
                label: 'name'
            },
            tableData: [],
            srcList:[],
            businessId: "", //商家id
            communityList: [], //服务范围列表
            dataFormRules: {
                merchandiseName: [
                    { required: true, message: "不能为空", trigger: "blur" },
                    { min: 1, max: 10, message: "长度在1到10个字符", trigger: "blur" },
                ],
                unitPrice: [{ required: true, message: "不能为空", trigger: "blur" }],
                serviceFee: [{ required: true, message: "不能为空", trigger: "blur" }],
                remark: [
                    { min: 0, max: 300, message: "长度在0到300个字符", trigger: "blur" },
                ],
                secondLevellId: [
                    { required: true, message: "不能为空", trigger: "blur" },
                ],
                isSubsidy: [{ required: true, message: "不能为空", trigger: "blur" }],
            },
            id: "",
            doctorList: [], //专家数据
            isAddDoctor: true,
            doctorId: "", //专家id
            helpId: "",
            loading: true,
            secondServiceList: [],
        };
    },
    methods: {
        
        handleNodeDictionary(data, node, vuecomponent){
          this.merchantId =data.id;
          this.getTableList();
        },
        bigimage(url){
            this.srcList = [url];
        },
        /* 
        修改table header的背景色
        */
        tableHeaderColor({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return "background-color:#bee1f4;color:#6f7075;font-weight: 500;";
            }
        },
        //上架下架
        changePutaway(item) {
            console.log(item);
            //上架
            if (item.isPutaway) {
                this.$postForm("omc/merchandis/on", { id: item.id}).then((res) => {
                    if (res.code == 200) {
                        this.$message({ message: "上架成功", type: "success" });
                        this.getTableList();
                    } else {
                        this.$message({ message: res.message, type: "error" });
                        // 避免switch开关状态改变
                        item.isPutaway = !item.isPutaway
                    }
                });
            } else {
                //下架
                this.$postForm("omc/merchandis/off", { id: item.id} ).then((res) => {
                    if (res.code == 200) {
                        this.$message({ message: "下架成功", type: "success" });
                        this.getTableList();
                    } else {
                        this.$message({ message: res.message, type: "error" });
                        // 避免switch开关状态改变
                        item.isPutaway = !item.isPutaway
                    }
                });
            }
        },
        /* 
        表格中的编辑
      */
        EditRow(index, row) {
            this.addForm = {
                id: row.id,
                merchandiseName:row.merchandiseName,
                unitPrice:row.unitPrice,
                unit:row.unit,
                imgsCode:row.imgsCode,
                particulars:row.particulars,
                secondLevellId:row.secondLevellId,
                merchantId:row.merchantId,
                isSubsidy:0,
                serviceFee:0,
                communityIds:0,
            }
            this.operation = false;//修改的
            this.isAdd = false;
            this.dialogVisible = true;//dialog模态框打开
        },
        /* 
          新增小项 弹出dialog模态框
        */
        appendDictionary(data) {
            console.log(data);
            this.dialogVisible = true;//dialog模态框打开
            this.isAdd = true;
            this.addForm = {
                merchandiseName:'',
                unitPrice:'',
                unit:0,
                imgsCode:'',
                particulars:'',
                secondLevellId:'',
                merchantId:data.id,
                isSubsidy:0,
                serviceFee:0,
                communityIds:0,
            }

        },
        //数据上传
        submitForm() {
            this.$refs.dataForm.validate((valid) => {
                if (valid) {
                    if (this.isAdd) {
                        let param = this.addForm;
                        this.$postJson("omc/merchandis/add", param).then(
                            (res) => {
                                if (res.code == 200) {
                                    this.dialogVisible = false;
                                    this.getTableList();
                                    this.$message({ message: res.message, type: "success" });
                                } else {
                                    this.$message({ message: res.message, type: "error" });
                                }
                            }
                        );
                    } else {
                        let param = this.addForm;
                        this.$postJson("omc/merchandis/update", param).then((res) => {
                            if (res.code == 200) {
                                this.dialogVisible = false;
                                this.getTableList();
                                this.$message({ message: res.message, type: "success" });
                            } else {
                                this.$message({ message: res.message, type: "error" });
                            }
                        });
                    }
                } else {
                    return false;
                }
            });
        },
        //上传图片
        upload(param) {
            var fileObj = param.file;
            if (fileObj != undefined) {
                // FormData 对象
                var form = new FormData();
                // 文件对象
                form.append("file", fileObj);
                form.append("fileType", "picture");
                form.append("bucketName", "cmny-oss");
                console.log(form);
                this.$postFormData("dmc/file/uploadFile", form).then((res) => {
                    if (res.code == 200) {
                        this.addForm.imgsCode = res.result;
                        this.$message({ message: res.message, type: "success" });
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message,
                        });
                    }
                });
            }
        },

        /* 
          图片验证
        */
        beforeUpload(file) {
            console.log(file);
            let isPNG = false;
            file.type == "image/gif" ? (isPNG = false) : (isPNG = true);
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isPNG) {
                this.$message.error("上传图片格式不能是 gif 格式");
            }
            if (!isLt2M) {
                this.$message.error("上传头像图片大小不能超过 2MB");
            }
            return isPNG && isLt2M;
        },

        // 删除图片
        closeImg(e) {
            e.stopPropagation();
            this.addForm.imgsCode = undefined;
        },
        //查询列表
        getTableList() {
            let param = {
                merchantId: this.merchantId * 1,
                pageSize:999
            };
            this.$postJson("omc/merchandis/select", param).then((res) => {
                if (res.code == 200) {
                    this.tableData = res.result.list;
                } else {
                    this.tableList = [];
                }
            });
        },
        //查询商家列表
        getBusiness() {
            let param = {
              pageNum: 1,
              pageSize: 999
            };
            this.treeList = [{
                id: 1000,
                name: '平台',
                remark: '平台',
            }];
            this.merchantId = 1000;
            this.getTableList();
            this.$postJson("uac/merchant/select", param).then((res) => {
                if (res.code == 200) {
                  for (let i = 0; i < res.result.list.length; i++) {
                    this.treeList.push({
                        id: res.result.list[i].id,
                        name: res.result.list[i].merchantName,
                        remark: res.result.list[i].remark,
                    })
                  }
                }
            });
        },
        getSecondServiceList(){
            this.$postJson('omc/serviceLevel/select').then(res=>{
                if(res.code==200){
                    this.secondServiceList = res.result;
                }   
            }); 
        },
        //关闭弹窗
        closeDialogReset() {
            this.$refs.dataForm.resetFields(); //移除校验结果并重置字段值
            this.addForm = {
                merchandiseName:'',
                unitPrice:'',
                unit:0,
                imgsCode:'',
                particulars:'',
                secondLevellId:'',
                merchantId:'',
                isSubsidy:0,
                serviceFee:0
            }
        },
        //修改
        fix(row) {
            console.log(row, "////");
            this.isAdd = false;
            this.dialogVisible = true;
            this.addForm = JSON.parse(JSON.stringify(row));
            this.addForm.unitPrice = String(row.unitPrice);
            // 0 , 1 
            this.addForm.isSubsidy = row.isSubsidy ? 1 : 0
            this.id = row.id;
        },
        //删除
        delet(row) {
            this.$confirm("是否删除此条数据?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                center: true,
            }).then(() => {
                this.$postForm("omc/merchandis/delete", { id: row.id }).then((res) => {
                    if (res.code == 200) {
                        this.$message({ type: "success", message: "删除成功!" });
                        this.getTableList();
                    } else {
                        this.$message({ type: "error", message: res.message });
                    }
                });
            });
        },

    },
    mounted() {
        this.getBusiness();
        this.getSecondServiceList();
    },
};
</script>
<style lang="scss" scoped>
.dictionary {
    width: 100%;
    height: 98%;
    margin-top: 5px;
    background: #FEFEFE;

    .dictionary-left {
        float: left;
        width: 20%;
        height: 100%;
        border: 1px #bee1f4 solid;
        margin-right: 2%;
        box-sizing: border-box;
        min-height: 600px;
    }

    .dictionary-right {
        float: right;
        width: 76%;
        height: 100%;
        margin-right: 2%;
        box-sizing: border-box;
    }

    .dictionary-row {
        height: 54px;
        line-height: 54px;
        background-color: #bee1f4;
        color: #6f7075;
        font-weight: 500;
        border: 1px #bee1f4 solid;
    }

    .dictionary-row-span-ml {
        height: 54px;
        line-height: 54px;
        margin-left: 10px;
    }

    .custom-tree-node {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        padding-right: 8px;
    }

    .vertical-align-cursor {
        vertical-align: middle;
        cursor: pointer;
        width: 15px;
        height: 15px;
    }

    .imgSize {
        vertical-align: middle;
        cursor: pointer;
        width: 20px;
        height: 20px;
    }
}

::deep .el-collapse-item__header {
    font-size: 18px;
}

.remark {
    width: 100%;
}

.world {
    height: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.unit {
    position: absolute;
    left: 150px;
    top: 50%;
    transform: translateY(-50%);
}

.closeIcon {
    z-index: 999;
    position: absolute;
    top: 0;
    left: 130px;
    font-size: 16px;
}
</style>
   